import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { get } from "src/services/http-service";
import DenseList from 'src/components/DenseList';
import SblDialog from 'src/components/SblDialog';
import Loading from 'src/components/Loading';
import LocalStorageService from 'src/services/local-storage-service';

function SblListPage() {

  const [categories, setCategories] = useState([]);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState([]);
  const [lawDocuments, setLawDocuments] = useState([]);
  const [sblId, setSblId] = useState(-1);
  const [fetchAll, setFetchAll] = useState(false);
  const localStorageService = new LocalStorageService();

  document.title = 'Lagar | Infosoc';

  const selectCategory = async (index, entry) => {
    setLawDocuments([]);
    setSelectedCategoryIndex(index);
    const response = await get(`/lawdocuments/${entry.id}/categories?fetchAll=` + fetchAll)
    setLawDocuments(response.entries);
  }

  useEffect(() => {
    
    // If ALL_LAWS_KEY is set to true then circumvent DB access for register 1 and 2
    let allLawsSelected = localStorageService.get(localStorageService.ALL_LAWS_KEY());

    if (allLawsSelected == null) {
      allLawsSelected = true;
    }

    if (typeof allLawsSelected === 'boolean') {
      setFetchAll(allLawsSelected);
    }

    (async () => {
      const response = await get('/lawdocuments/categories');
      setSelectedCategoryIndex(0);
      setCategories(response.entries);

      const legalDocuments = await get(`/lawdocuments/${response.entries[0].id}/categories?fetchAll=` + fetchAll)
      setLawDocuments(legalDocuments.entries);
    })();
  }, [fetchAll]);

  if(categories.length===0){
    return <Box mt={10} ml={2}><Loading /></Box>
  }

  return (
    <Box sx={{ flexGrow: 1 }} mt={10} ml={2}>
      <Stack direction="row">
        <Box minWidth={300}>
          <DenseList entries={categories} onSelect={(index, entry) => selectCategory(index, entry)} selectedIndex={selectedCategoryIndex} />
        </Box>
        <Box width={1}>
          <DenseList entries={lawDocuments} offsetTop={120} showFilter={true} onSelect={(index, entry) => setSblId(entry.id)} />
        </Box>
      </Stack>
      <SblDialog open={sblId !== -1} onClose={() => setSblId(-1)} id={sblId} />
    </Box>
  );
}


export default SblListPage;